enum IncomeTypeEnum {
    Other = 'OTHER',
    PaygFullTime = 'PAYG_FULL_TIME',
    PaygPartTime = 'PAYG_PART_TIME',
    SelfEmployed = 'SELF_EMPLOYED',
}

export default IncomeTypeEnum;
